
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Positions",
      function () {
        return require("private-next-pages/Positions.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Positions"])
      });
    }
  